import {
  Box,
  createTheme,
  IconButton,
  Button,
  MenuItem,
  ThemeProvider,
} from "@mui/material";
import Badge from "@mui/material/Badge";
import { default as MenuIcon } from "@mui/icons-material/Menu";
import { Auth } from "aws-amplify";
import Menu from "@mui/material/Menu";
import React from "react";
import { ROUTES } from "../Routes";

const mobileTheme = createTheme({
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 22,
  },
});

export default function MobileMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isLoggedOn = props.isLoggedOn;

  if (isLoggedOn === false) {
    return (
      <Button
        size="small"
        variant="outlined"
        style={{ color: "#fff", borderColor: "#fff" }}
        href={ROUTES.LOGIN}
      >
        Logga in / Skapa Konto
      </Button>
    );
  }
  const id = props.id;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const signOut = () => {
    Auth.signOut();
    handleClose();
  };

  return (
    <>
      <ThemeProvider theme={mobileTheme}>
        <Box display={{ xs: "block", sm: "block", md: "none" }}>
          <Badge
            color="error"
            variant="dot"
            fontSize="large"
            overlap="circular"
            invisible={id ? true : false}
          >
            <IconButton
              edge="start"
              style={{ marginRight: "-30px" }}
              color="inherit"
              aria-label="menu"
              onClick={handleClick}
            >
              <MenuIcon />
            </IconButton>
          </Badge>

          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                window.location = "#availablejobs";
              }}
            >
              Annonser
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                window.location = "#myjobrequests";
              }}
            >
              Min Sida
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                window.location = ROUTES.MY_JOB_REQUESTS + "?createNewAd";
              }}
            >
              Lägg in Annons
            </MenuItem>
            {/** 
            <MenuItem
              onClick={() => {
                handleClose();
                window.location = ROUTES.ABOUT;
              }}
            >
              Om Oss
            </MenuItem>
*/}
            <MenuItem
              onClick={() => {
                handleClose();
                window.location = "#myprofile";
              }}
            >
              Mitt Konto
            </MenuItem>
            <MenuItem onClick={signOut}>Logga Ut</MenuItem>
          </Menu>
        </Box>
      </ThemeProvider>
    </>
  );
}
